import React, {useEffect, useMemo} from 'react';
import {Grid} from '@mui/material';
import {PlanProviderSelectOption} from '../../../hooks/usePlanNamesProviders';
import type {newPlanParentFields} from './builderSetUpNewFields';
import type {modelPortfolioField} from '../BuilderModify/builderModifyFieldTypes';
import {BuilderMandatesWrapper as MandatesWrapper} from '../pages/BuilderMandatesModal';
import {PlanFeesField} from '../CreateBuilder/BuilderPlanFees';
import {ShowIfDebugWrapper} from '../../../contexts/DebugProvider';
import {useAutoField} from '../../../components/AutoForm/useAutoForm';
import {UPDATES} from '../../../shared/UPDATES';
import {useShowMandateSelector} from '../hooks/builderSetUpNewHooks';
import {includesSaltus} from '../../../utils/includesSaltus';

export interface BuilderSubPlanProps {
  formikKeyPrefix: string;
  productProviders: PlanProviderSelectOption[] | undefined;
}

export const BuilderNewSubPlanDetails = ({
  formikKeyPrefix,
  productProviders,
}: BuilderSubPlanProps) => {
  const [parentProductIdField] = useAutoField<newPlanParentFields['productNameId']>(
    'setUpNew.parent.productNameId'
  );
  const [parentPlanProviderField] = useAutoField<newPlanParentFields['planProvider']>(
    'setUpNew.parent.planProvider'
  );
  const [, , subplanPlanProviderHelpers] = useAutoField<string | undefined>(
    `${formikKeyPrefix}.planProvider`
  );
  const [subplanProductNameIdField, , subplanProductNameIdHelpers] = useAutoField<
    string | undefined
  >(`${formikKeyPrefix}.productNameId`);

  const [mandateField] = useAutoField<modelPortfolioField | undefined>(
    `${formikKeyPrefix}.model`
  );

  const planProvider: string | null = parentPlanProviderField.value || null;
  const enableMandateField =
    !!parentPlanProviderField.value || !!parentProductIdField.value;

  const showMandateSelector = useShowMandateSelector();
  const isSaltus = useMemo(() => {
    const provider = productProviders?.find((p) => p.value === planProvider);
    return includesSaltus(provider?.label ?? '');
  }, [planProvider, productProviders]);

  useEffect(() => {
    subplanPlanProviderHelpers.setValue(
      UPDATES._532,
      parentPlanProviderField.value ?? '',
      true
    );
  }, [parentPlanProviderField.value]);

  useEffect(() => {
    subplanProductNameIdHelpers.setValue(
      UPDATES._533,
      parentProductIdField.value ?? '',
      true
    );
  }, [parentProductIdField.value]);
  return (
    <Grid pt={2} container direction="row" spacing={2}>
      {/* <Grid item xs={6}>
        <AutoField
          field={{
            disabled: !subproductProviders?.length || disableProviderField,
            ...builderPlanProviderField,
            label: subproductProviders?.length
              ? `Select subplan provider`
              : 'Loading plans',
            id: `${formikKeyPrefix}.planProvider`,
            type: ActionType.selectAutocomplete,
            options: subproductProviders || [],
          }}
          onBlur={() => {
            mandateHelpers.setValue(UPDATES._527, undefined, true);
          }}
        />
      </Grid> */}
      <Grid item xs={6}>
        <MandatesWrapper
          isChild
          showCurrentMandate={false}
          planProviderOptions={productProviders || []}
          formikKeyPrefix={formikKeyPrefix}
          disabledReason={
            !enableMandateField
              ? 'Select a parent plan provider first'
              : !subplanProductNameIdField.value
              ? 'Select a product type first'
              : undefined
          }
        />
      </Grid>
      <Grid item xs={12}>
        <ShowIfDebugWrapper>
          FormikKeyPrefix: {formikKeyPrefix}
          <br />
          parentProductIdField: {parentProductIdField.value}
        </ShowIfDebugWrapper>
        {/* PlanType: {planType} */}

        <PlanFeesField
          inModify={false}
          hasSubplan={false}
          requiresMandate={false}
          mandateId={
            mandateField.value && typeof mandateField.value === 'object'
              ? mandateField.value?.id
              : undefined
          }
          providerId={planProvider}
          productId={parentProductIdField.value} // just for the time being
          formikKeyPrefixWithoutFee={formikKeyPrefix}
          parentProductId={parentProductIdField.value}
          isSaltus={isSaltus}
        />
      </Grid>
    </Grid>
  );
};
